import { FollowButton, withFollow } from '@eventbrite/follow-organizer-ebui';
import { gettext } from '@eventbrite/i18n';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import '../../styles/followButton.scss';
import { FollowOrganizerProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
const FOLLOW_ORGANIZER_MINI_SIZE = 'mini';
const FOLLOW_ORGANIZER_HERO_ID = 'listings-root__follow-organizer_hero';
const FOLLOW_ORGANIZER_EXPIRED_ID = 'listings-root__follow-organizer_expired';

const EnhancedFollowButtton = withFollow(FollowButton);

const followOrganizerHeroFollowCountRender = (
    followCount: string,
): JSX.Element => {
    return (
        <div className="follow-organizer__follow-count">
            {parseInt(followCount, 10) > 1
                ? gettext('%(followCount)s followers', { followCount })
                : gettext('%(followCount)s follower', { followCount })}
        </div>
    );
};

export const FollowOrganizerWidget: React.FunctionComponent<FollowOrganizerProps> = (
    props,
) => {
    const { organizers, size, renderFollowCount } = props;

    return (
        <EnhancedFollowButtton
            isOnlyButton={true}
            organizerId={organizers[0]}
            size={size}
            renderFollowCount={renderFollowCount}
        />
    );
};

const FollowOrganizerHero = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_HERO_ID,
        },
        {
            ...props,
            size: FOLLOW_ORGANIZER_MINI_SIZE,
            renderFollowCount: followOrganizerHeroFollowCountRender,
        },
    );

const FollowOrganizerExpired = (props: FollowOrganizerProps) =>
    dynaMount(
        {
            Component: FollowOrganizerWidget,
            containerId: FOLLOW_ORGANIZER_EXPIRED_ID,
        },
        props,
    );

const FollowOrganizerMount = (props: FollowOrganizerProps): JSX.Element => (
    <>
        <FollowOrganizerHero {...props} />
        <FollowOrganizerExpired {...props} />
    </>
);

const FollowOrganizerRoot = (
    props: FollowOrganizerProps,
): JSX.Element | null => {
    if (isEmpty(props.organizerId)) {
        return null;
    }

    return <FollowOrganizerMount {...props} />;
};

export default FollowOrganizerRoot;
